import {useContext} from "react";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {faArrowRight, faAt, faEnvelope, faPhone} from "@fortawesome/pro-solid-svg-icons";

import {Styled} from "./MenuDrawer.styles";
import Drawer from "../../../lib/UIBookBrd/Drawer";
import {Local_Data} from "../../../Context";
import {MAIN_PAGE} from "../../../Routes";
import useS115 from "../../../lib/Hooks/useS115";
import useLanguage from "../../../lib/Hooks/useLanguage";
import {isNavItemActive, NAV_ITEMS} from "../navigationItems";
import {Contact__Values} from "../../../PageValues";

const MenuDrawer = () => {

    const [localData, setLocalData] = useContext<any>(Local_Data);

    const {t} = useTranslation()

    const {navigatePage} = useS115()

    const {language, changeLanguage} = useLanguage()

    const location = useLocation()

    const phone = Contact__Values.phoneNumbers[0]

    const onClose = () => {
        setLocalData((state: any) => ({...state, isMenuOpen: false}))
    }

    const title = (
        <Styled.Logo onClick={() => navigatePage(MAIN_PAGE)}>
            S115
        </Styled.Logo>
    )

    return (
        <Drawer
            isOpen={localData?.isMenuOpen ?? false}
            position={'left'}
            title={title}
            onClose={onClose}
        >
            <Styled.Content>
                <Styled.Items>
                    {NAV_ITEMS.map((item, index) => (
                        <Styled.Item
                            key={item.path}
                            $active={isNavItemActive(item, location.pathname)}
                            onClick={() => navigatePage(item.path)}
                        >
                            <Styled.ItemIndex>{`0${index + 1}`}</Styled.ItemIndex>
                            <Styled.ItemText>
                                <Styled.ItemLabel>{t(item.labelKey)}</Styled.ItemLabel>
                                {item.descriptionKey && (
                                    <Styled.ItemDescription>{t(item.descriptionKey)}</Styled.ItemDescription>
                                )}
                            </Styled.ItemText>
                            <Styled.ItemArrow icon={faArrowRight}/>
                        </Styled.Item>
                    ))}
                </Styled.Items>

                <Styled.Bottom>
                    <div>
                        <Styled.BlockTitle>{t('lbl_change_language')}</Styled.BlockTitle>
                        <Styled.LanguageRow style={{marginTop: '10px'}}>
                            {['pl', 'en'].map((code) => (
                                <Styled.LanguageButton
                                    key={code}
                                    $active={language === code}
                                    onClick={() => changeLanguage(code)}
                                >
                                    {code.toUpperCase()}
                                </Styled.LanguageButton>
                            ))}
                        </Styled.LanguageRow>
                    </div>

                    <div>
                        <Styled.BlockTitle>{t('lbl_contact')}</Styled.BlockTitle>
                        <Styled.ContactList style={{marginTop: '10px'}}>
                            <Styled.ContactLink href={`tel:${phone.replace(/\s/g, '')}`}>
                                <Styled.ContactIcon icon={faPhone}/>
                                {phone}
                            </Styled.ContactLink>
                            <Styled.ContactLink href={`mailto:${Contact__Values.emailAddress}`}>
                                <Styled.ContactIcon icon={faEnvelope}/>
                                {Contact__Values.emailAddress}
                            </Styled.ContactLink>
                            <Styled.ContactLink
                                href={Contact__Values.instagram}
                                target={'_blank'}
                                rel={'noreferrer'}
                            >
                                <Styled.ContactIcon icon={faAt}/>
                                {Contact__Values.instagramHandle}
                            </Styled.ContactLink>
                        </Styled.ContactList>
                    </div>
                </Styled.Bottom>
            </Styled.Content>
        </Drawer>
    )
}

export default MenuDrawer
